export enum ChatContextType {
    None = 0,
    Global = 1,
    Bookview = 2,
    Notebooks = 3,
}
